var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"refSvgContainer",staticClass:"container"},[(true || _vm.body == 'SEDAN' || _vm.body == 'SUV')?_c('svg-sedan',{attrs:{"selectedSchemeParts":_vm.uniqueSelectedSchemeParts}}):_c('svg-other',{attrs:{"selectedSchemeParts":_vm.uniqueSelectedSchemeParts}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }